import { all } from 'redux-saga/effects';

import ghostSaga from './sagas/ghost';
import supportSaga from './sagas/support';
import appsSaga from './sagas/apps';
import webhooksSaga from './sagas/webhooks';
import webhookSaga from './sagas/webhook';
import certificatesSaga from './sagas/certificates';
import profileSaga from './sagas/profile';

export default function* rootSaga() {
  yield all([
    ghostSaga(),
    supportSaga(),
    appsSaga(),
    webhooksSaga(),
    webhookSaga(),
    certificatesSaga(),
    profileSaga()
  ]);
}
